<template>
  <div :class="{ 'hidden': hidden }" class="v-pagination">
    <el-pagination :background="background" :current-page.sync="currentPage" :page-size.sync="pageSize" :layout="layout"
      :page-sizes="pageSizes" :pager-count='pagerCount' :total="total" :hide-on-single-page="false" v-bind="$attrs"
      @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    <div>
      <v-button :name="$t('common.ok2')" size="mini" @click="handleCurrentChange"></v-button>
    </div>
    <slot name="page-btn"></slot>
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'VPagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    //页码按钮的数量，当总页数超过该值时会折叠	
    pagerCount: {
      type: Number,
      default: 7
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="scss">
.v-pagination {
  @include whiteBg;
  padding: 20px 16px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-pagination .el-select .el-input {
    margin: 0;
  }

  .el-pagination__total {
    color: $titleText !important;
  }

  .el-pager li,
  .el-pagination button,
  .el-pagination span:not([class*=suffix]),
  .el-input--mini .el-input__inner,
  .el-pagination__editor.el-input .el-input__inner {
    height: 24px;
    line-height: 24px;
    color: $headerText;
  }

  .el-pagination__jump {
    margin-right: 16px;
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: $blueNormal;
    color: $white;
  }
}

.v-pagination.hidden {
  display: none;
}
</style>
